(function ($) {
  'use strict'

  const root = this

  /**
     *
     * @param name
     * @param value
     * @param days
     */
  root.zgCreateCookie = function (name, value, days) {
    let expires = ''

    if (days) {
      const date = new Date()
      date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000))

      expires = '; expires=' + date.toGMTString()
    }

    document.cookie = name + '=' + value + expires + '; path=/'
  }

  /**
     *
     * @param name
     * @returns {*}
     */
  root.zgReadCookie = function (name) {
    const nameEQ = name + '='
    const ca = document.cookie.split(';')
    for (let c of ca) {
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length)
      }

      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length)
      }
    }

    return null
  }

  /**
     *
     * @param name
     */
  root.zgEraseCookie = function (name) {
    root.zgCreateCookie(name, '', -1)
  }

  // cookie newsletter modal
  $(() => {
    const newsletterContainer = 'content_newsletter_modal'
    const newsletterCookieName = 'ZG-showNewsletter-' + window.SGL_JS_THEME
    const url = window.makeUrl({
      module: 'eshop',
      manager: 'cms',
      action: 'list',
      type: 'block_newsletterModal',
      master: 'master_blank',
      skip_redir: '1'
    })

    // CHECK IF THERE IS COOKIE
    if (!root.zgReadCookie(newsletterCookieName)) {
      root.loadAjaxFile(null, newsletterContainer, url)

      $(document).on('zg.loadAjaxFile.success', (e, fileName, containerSelector) => {
        if (newsletterContainer === containerSelector) {
          const $newsletterContainer = $(document).find('#' + newsletterContainer)
          const $newsletterModal = $newsletterContainer.closest('.modal')
          const $newsletterForm = $newsletterContainer.find('#form_newsletter_modal')

          // Init any form to validate
          $newsletterModal.find('[data-zg-validate="to-validate"]').zg_validate(window.ZG_CONFIG)

          // Show modal
          $newsletterModal.modal('show')

          // Listen for modal close
          $newsletterModal.on('hide.bs.modal', () => {
            root.zgCreateCookie(newsletterCookieName, '1', 7) // 1 week
          })

          // When user submit the form
          $newsletterForm.on('submit', () => {
            root.zgCreateCookie(newsletterCookieName, '1', 7) // 1 week
          })
        }
      })
    }
  })
}).call(this, jQuery)
